var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',[_vm._v("\n    "+_vm._s(_vm.__n(':count set|:count sets', _vm.value))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }